import { Pipe, PipeTransform } from '@angular/core';
import { WorkflowStatusMeta } from './core/interface';
import {
  Partners,
  PolicyStatus,
  RoleType,
} from '@lockton-apps/shared/interfaces';
import { getPolicyStatusMeta } from './core/policy-status-meta';

@Pipe({
  name: 'policyStatusMeta',
  standalone: true,
})
export class PolicyStatusMetaPipe implements PipeTransform {
  transform(
    status: PolicyStatus,
    partner?: Partners,
    userRole?: RoleType | null
  ): WorkflowStatusMeta {
    return getPolicyStatusMeta(status, partner, userRole);
  }
}
